@if (shortcuts.helpOpen()) {
  <div class="shortcuts-backdrop" (click)="shortcuts.closeHelp()"></div>
  <div class="shortcuts-dialog"
       role="dialog"
       aria-modal="true"
       aria-labelledby="shortcuts-help-title"
       cdkTrapFocus
       [cdkTrapFocusAutoCapture]="true">
    <header class="shortcuts-dialog__header">
      <h2 id="shortcuts-help-title">Raccourcis clavier</h2>
      <button type="button" class="shortcuts-dialog__close" aria-label="Fermer l'aide" (click)="shortcuts.closeHelp()">
        <ng-icon name="iconoirXmark" size="18" />
      </button>
    </header>
    <ul class="shortcuts-list">
      @for (row of rows(); track row.label) {
        <li>
          <span class="shortcuts-list__label">{{ row.label }}</span>
          <span class="shortcuts-list__keys">
            @for (key of row.keys; track $index) {
              <kbd>{{ key }}</kbd>
            }
          </span>
        </li>
      }
    </ul>
  </div>
}
